export const translationVariables = {
  UPSELL_LOGGED_OUT_PAGE_IMAGES_TEXT: {
    values: { number: '1' },
  },
  UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_HEADER_1: {
    values: { number: 5 },
  },
};

export const upltTrackingParameters = {
  GO_TO_PRODUCT_BTN: {
    premium: 'uplt_988',
    projobs: 'uplt_987',
  },
  PRODUCT_CTA: {
    premium: 'uplt_986',
    projobs: 'uplt_985',
  },
};
